export const dataLayerLogger = ({ name, message, title, logLevel }) => {
  if (process.client && logLevel === "error") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error",
      error_id: name,
      error_description: message,
      error_title: title
    });
  }
};
